import type { LocalizedString } from "./Locale.js";

export enum MacaroonVariant {
	Chocolate = "Chocolate",
	SaltedCaramel = "SaltedCaramel",
	Pistachio = "Pistachio",
	Raspberry = "Raspberry",
	Lemon = "Lemon",
}

export const macaroonVariantKeyMap = {
	[MacaroonVariant.Chocolate]: "chocolate" as const,
	[MacaroonVariant.SaltedCaramel]: "saltedCaramel" as const,
	[MacaroonVariant.Pistachio]: "pistachio" as const,
	[MacaroonVariant.Raspberry]: "raspberry" as const,
	[MacaroonVariant.Lemon]: "lemon" as const,
} satisfies Record<MacaroonVariant, string>;

export const macaroonVariantKeyReversedMap = Object.fromEntries(
	Object.entries(macaroonVariantKeyMap).map(([key, value]) => [value, key] as const),
) as {
	// eslint-disable-next-line no-use-before-define
	[Option in keyof typeof macaroonVariantKeyMap as (typeof macaroonVariantKeyMap)[Option]]: Option;
};

export const macaroonVariantNameMap: Record<MacaroonVariant, LocalizedString> = {
	[MacaroonVariant.Chocolate]: {
		cs: "čokoládová",
	},
	[MacaroonVariant.SaltedCaramel]: {
		cs: "slaný karamel",
	},
	[MacaroonVariant.Pistachio]: {
		cs: "pistáciová",
	},
	[MacaroonVariant.Raspberry]: {
		cs: "malinová",
	},
	[MacaroonVariant.Lemon]: {
		cs: "citronová",
	},
};
